import { MenuItem, TextField } from '@material-ui/core'
import React from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import styles from '../styles'

interface IOption{
    id:string,
    name:string
}

interface ISelectProps{
    field: ControllerRenderProps<Record<string, any>>,
    label: string,
    options?: IOption[]
}

export default function Select({field,label,options = []}:ISelectProps) {
    const classes = styles();
    return (
        <TextField
            select
            className={classes.attributeField}
            variant="outlined"
            label={label}
            required
            inputProps={
                {
                    "data-testid": `${field.name}-select`,
                }
            }
            {...field}
        >
                {
                    options.map(val => (
                        <MenuItem value={val.id} key={val.name}>
                            {val.name}
                        </MenuItem>
                    ))
                }
        </TextField>
    )
}
